<script setup>
defineProps({
  // A centred row for the bottom of the page on small screens
  inline: {
    type: Boolean,
    default: false,
  },
});

// get the current year
const year = new Date().getFullYear();

const links = [
  { href: "PrivacyPolicy.pdf", label: "Privacy policy" },
  { href: "TermsOfUse.pdf", label: "Terms of Use" },
  { href: "mailto:support@makemea.com", label: "Contact us" },
];
</script>

<template>
  <section
    v-if="inline"
    class="flex flex-col items-center gap-1 pt-4 pb-[max(1.25rem,env(safe-area-inset-bottom))] text-xs text-gray-400"
  >
    <nav class="flex flex-wrap justify-center gap-x-4 gap-y-1">
      <a
        v-for="link in links"
        :key="link.label"
        :href="link.href"
        target="_blank"
        rel="noopener"
        class="rounded-lg px-1 hover:bg-gray-100 hover:text-primary"
      >
        {{ link.label }}
      </a>
    </nav>
    <span>© {{ year }} MakeMeA Ltd.</span>
  </section>
  <!-- A head-footer, on larger screens only -->
  <section v-else class="hidden md:flex">
    <div class="mt-1 -mb-7 z-50 w-full flex">
      <a
        v-for="link in links"
        :key="link.label"
        :href="link.href"
        target="_blank"
        rel="noopener"
        class="text-gray-400 hover:text-primary hover:bg-gray-200 hover:opacity-40 px-1 ml-3 rounded-lg text-sm"
      >
        <p>{{ link.label }}</p>
      </a>
      <span class="text-gray-400 ml-auto mr-3 my-0.5 text-sm"
        >© {{ year }} MakeMeA Ltd.</span
      >
    </div>
  </section>
</template>
